module.exports = __webpack_public_path__ + "img/daisy-min.d55269fa.png";